import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export default function Features() {
  const feats = [
    'Todo o conteúdo necessário para medalhar na OBMEP do zero e sem decorebas!',
    'Aulas catalogadas em nível, tópico, assunto, incidência, importância...',
    'Aulão ensinando tudo o que você precisa para estudar bem — conforme a ciência, sem achismo!',
    'Resumo de todas as aulas para download imediato!',
    'Método de revisão eficiente para evitar que o esquecimento corroa o conhecimento!',
    'Listas de questões personalizadas com todas as 108 provas da OBMEP catalogadas — 1400+ questões!',
    'Estude com o maior acervo de questões catalogadas em conteúdo da história da OBMEP!',
    'Mais de 12 cronogramas personalizados para seguir o melhor caminho de estudos possível!',
    'Ficha técnica dos cronogramas com 96 diferentes guias para você estudar como preferir!',
    'Podcasts com alunos bem-sucedidos nas olimpíadas científicas para fins de motivação!',
    'Premiação enviada por correio para os pitagóricos que alcançarem ouro na OBMEP 2024!',
  ];
  const stats = [
    { n: '250+', label: 'aulas do básico ao profundo' },
    { n: '1000+', label: 'provas de mais de 50 olimpíadas' },
    { n: '5000+', label: 'questões para treinar bastante' },
  ];
  return (
    <section className="gradient-bg-light py-20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[#a020c9] tracking-widest text-sm font-semibold uppercase">— Tem mais —</p>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-[#7a1fb0] mt-2">E não acabou por aí!</h2>
          <div className="h-1 w-24 bg-[#ec2fd2] mx-auto mt-4 rounded"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-white rounded-2xl p-8 text-center shadow-lg">
              <div className="text-4xl md:text-5xl font-black text-[#a020c9]">{s.n}</div>
              <div className="text-[#3a1450] mt-2">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-4 max-w-4xl mx-auto">
          {feats.map((f, i) => (
            <div key={i} className="flex items-start gap-3 bg-white/70 rounded-lg p-4">
              <CheckCircle2 className="text-[#a020c9] flex-shrink-0 mt-0.5" size={22} />
              <span className="text-sm text-[#3a1450]">{f}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
